import { compose, equals } from 'ramda';

/**
 * Gets the id of a match
 *
 * @param match
 */
const getId = (match) => match.id;
/**
 * Gets the state of a match
 *
 * @param match
 */
const getState = (match) => match.status;

/**
 * Checks if a match is in challenge state
 *
 * @param match
 */
const isChallenge = compose(equals("challenge"), getState);
/**
 * Checks if a match is in open state
 *
 * @param match
 */
const isOpen = compose(equals("open"), getState);
/**
 * Checks if a match is in deleted state
 *
 * @param match
 */
const isDeleted = compose(equals("deleted"), getState);
/**
 * Checks if a match is in exception state
 *
 * @param match
 */
const isException = compose(equals("exception"), getState);
/**
 * Checks if a match is in protest state
 *
 * @param match
 */
const isProtest = compose(equals("protest"), getState);
/**
 * Checks if a match is in closed state
 *
 * @param match
 */
const isClosed = compose(equals("closed"), getState);

/**
 * Generated bundle index. Do not edit.
 */

export { getId, getState, isChallenge, isClosed, isDeleted, isException, isOpen, isProtest };
//# sourceMappingURL=play-utility-match.js.map
